import createIcon from '../../createIcon';

/**
 * @component @name ShareLocation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMDIwMyAxOS45Mjk4VjIxLjk0OThDMTUuMDMwMyAyMS43NDk4IDE2Ljg2MDMgMjAuOTQ5OCAxOC4zNDAzIDE5LjczOThMMTYuOTIwMyAxOC4zMDk4QzE1LjgxMDMgMTkuMTY5OCAxNC40ODAzIDE5Ljc0OTggMTMuMDIwMyAxOS45Mjk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuMDMwMjcgMTEuOTk5OEM0LjAzMDI3IDcuOTQ5OCA3LjA2MDI3IDQuNTg5OCAxMC45ODAzIDQuMDY5OFYyLjA0OThDNS45NTAyNyAyLjU3OTggMi4wMzAyNyA2LjgzOTggMi4wMzAyNyAxMS45OTk4QzIuMDMwMjcgMTcuMTU5OCA1Ljk1MDI3IDIxLjQxOTggMTAuOTgwMyAyMS45NDk4VjE5LjkyOThDNy4wNjAyNyAxOS40MDk4IDQuMDMwMjcgMTYuMDQ5OCA0LjAzMDI3IDExLjk5OThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkuOTUwMyAxMC45OTk4SDIxLjk3MDNDMjEuNzcwMyA4Ljk4OTggMjAuOTcwMyA3LjE1OTggMTkuNzYwMyA1LjY3OThMMTguMzMwMyA3LjEwOTgxQzE5LjE5MDMgOC4yMDk4MSAxOS43NzAzIDkuNTM5OCAxOS45NTAzIDEwLjk5OThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTguMzQwMyA0LjI1OThDMTYuODYwMyAzLjA0OTggMTUuMDIwMyAyLjI0OTggMTMuMDIwMyAyLjA0OThWNC4wNjk4QzE0LjQ4MDMgNC4yNDk4IDE1LjgxMDMgNC44Mjk4IDE2LjkyMDMgNS42ODk4TDE4LjM0MDMgNC4yNTk4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjMzMDMgMTYuODk5OEwxOS43NjAzIDE4LjMxOThDMjAuOTcwMyAxNi44Mzk4IDIxLjc3MDMgMTUuMDA5OCAyMS45NzAzIDEyLjk5OThIMTkuOTUwM0MxOS43NzAzIDE0LjQ1OTggMTkuMTkwMyAxNS43ODk4IDE4LjMzMDMgMTYuODk5OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi4wMDAzIDExLjA5OThDMTYuMDAwMyA4LjYwOTgxIDE0LjEwMDMgNi45OTk4IDEyLjAwMDMgNi45OTk4QzkuOTAwMjcgNi45OTk4IDguMDAwMjcgOC42MDk4MSA4LjAwMDI3IDExLjA5OThDOC4wMDAyNyAxMi43NTk4IDkuMzMwMjcgMTQuNzI5OCAxMi4wMDAzIDE2Ljk5OThDMTQuNjcwMyAxNC43Mjk4IDE2LjAwMDMgMTIuNzU5OCAxNi4wMDAzIDExLjA5OThaTTEyLjAwMDMgMTEuOTk5OEMxMS40MTAzIDExLjk5OTggMTAuOTMwMyAxMS41MTk4IDEwLjkzMDMgMTAuOTI5OEMxMC45MzAzIDEwLjMzOTggMTEuNDEwMyA5Ljg1OTggMTIuMDAwMyA5Ljg1OThDMTIuNTkwMyA5Ljg1OTggMTMuMDcwMyAxMC4zMzk4IDEzLjA3MDMgMTAuOTI5OEMxMy4wNzAzIDExLjUxOTggMTIuNTkwMyAxMS45OTk4IDEyLjAwMDMgMTEuOTk5OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShareLocation = createIcon('ShareLocation', [
  [
    'path',
    {
      d: 'M13.0203 19.9298V21.9498C15.0303 21.7498 16.8603 20.9498 18.3403 19.7398L16.9203 18.3098C15.8103 19.1698 14.4803 19.7498 13.0203 19.9298Z',
      key: '1rkkks',
    },
  ],
  [
    'path',
    {
      d: 'M4.03027 11.9998C4.03027 7.9498 7.06027 4.5898 10.9803 4.0698V2.0498C5.95027 2.5798 2.03027 6.8398 2.03027 11.9998C2.03027 17.1598 5.95027 21.4198 10.9803 21.9498V19.9298C7.06027 19.4098 4.03027 16.0498 4.03027 11.9998Z',
      key: 'sj4gsa',
    },
  ],
  [
    'path',
    {
      d: 'M19.9503 10.9998H21.9703C21.7703 8.9898 20.9703 7.1598 19.7603 5.6798L18.3303 7.10981C19.1903 8.20981 19.7703 9.5398 19.9503 10.9998Z',
      key: '1cyhqs',
    },
  ],
  [
    'path',
    {
      d: 'M18.3403 4.2598C16.8603 3.0498 15.0203 2.2498 13.0203 2.0498V4.0698C14.4803 4.2498 15.8103 4.8298 16.9203 5.6898L18.3403 4.2598Z',
      key: '1jw4w1',
    },
  ],
  [
    'path',
    {
      d: 'M18.3303 16.8998L19.7603 18.3198C20.9703 16.8398 21.7703 15.0098 21.9703 12.9998H19.9503C19.7703 14.4598 19.1903 15.7898 18.3303 16.8998Z',
      key: 'p7fac2',
    },
  ],
  [
    'path',
    {
      d: 'M16.0003 11.0998C16.0003 8.60981 14.1003 6.9998 12.0003 6.9998C9.90027 6.9998 8.00027 8.60981 8.00027 11.0998C8.00027 12.7598 9.33027 14.7298 12.0003 16.9998C14.6703 14.7298 16.0003 12.7598 16.0003 11.0998ZM12.0003 11.9998C11.4103 11.9998 10.9303 11.5198 10.9303 10.9298C10.9303 10.3398 11.4103 9.8598 12.0003 9.8598C12.5903 9.8598 13.0703 10.3398 13.0703 10.9298C13.0703 11.5198 12.5903 11.9998 12.0003 11.9998Z',
      key: 'h458oy',
    },
  ],
]);

export default ShareLocation;
